var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircleCancel = function SvgCircleCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#5B9255",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.573 24.128a.86.86 0 0 0 .798 0c6.677-3.587 7.15-10.595 7.145-12.587a.823.823 0 0 0-.497-.753l-6.708-2.971a.838.838 0 0 0-.678 0L8.972 10.79a.825.825 0 0 0-.494.744c-.028 1.982.371 9.005 7.095 12.595Zm-2.345-9.55 1.911 1.91 3.578-3.577 1.178 1.178-4.756 4.756-3.089-3.09 1.178-1.178Z",
    fill: "#5B9255"
  })));
};
export default SvgCircleCancel;